export default class Categoria {
	constructor(
		nome=''
	){
		this.nome = nome;
	}
}